import React from "react";
import styled from "styled-components";
import moment from "moment";
import CalendarVector from "../../../assets/Vector/CalendarVector.svg";

const CalenderDiv = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  align-items: center;
`;
const CalenderDate = styled.p`
  color: #585858;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  padding: 5px 24px 0 0;
`;
function PageSyncCal() {
  const currentDate = moment();
  const formattedDate = currentDate.format("Do MMMM, YYYY");
  return (
    // <div>Heading</div>
    <CalenderDiv>
      <img
        src={CalendarVector}
        alt="/calendarvector"
        style={{ paddingTop: "10px" }}
      />
      <CalenderDate>{formattedDate}</CalenderDate>
    </CalenderDiv>
  );
}

export default PageSyncCal;
